'use strict';

var WEEKDAY_INDEX = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
};

var WEEKDAY_FROM_EN = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
};

function getConfig() {
    return window.SitePreferences && window.SitePreferences.SHIPPING_PROMISE
        ? window.SitePreferences.SHIPPING_PROMISE
        : null;
}

function getZonedParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: timeZone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
    var map = {};
    formatter.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') {
            map[part.type] = part.value;
        }
    });

    var hour = parseInt(map.hour, 10);
    if (hour === 24) {
        hour = 0;
    }

    return {
        weekday: WEEKDAY_FROM_EN[map.weekday],
        hour: hour,
        minute: parseInt(map.minute, 10),
        second: parseInt(map.second, 10),
        dateKey: map.year + '-' + map.month + '-' + map.day
    };
}

function isWeekdayAllowed(parts, config) {
    var allowed = config.weekdays || [];
    for (var i = 0; i < allowed.length; i++) {
        var name = String(allowed[i]).toLowerCase();
        if (WEEKDAY_INDEX[name] === parts.weekday) {
            return true;
        }
        if (parseInt(allowed[i], 10) === parts.weekday) {
            return true;
        }
    }
    return false;
}

function isHoliday(parts, config) {
    var holidays = config.holidays || [];
    return holidays.indexOf(parts.dateKey) !== -1;
}

function secondsOfDay(hour, minute, second) {
    return ((hour || 0) * 3600) + ((minute || 0) * 60) + (second || 0);
}

function hasReachedStart(parts, config) {
    var nowSeconds = secondsOfDay(parts.hour, parts.minute, parts.second);
    var startSeconds = secondsOfDay(config.startHour, config.startMinute, 0);
    return nowSeconds >= startSeconds;
}

function msUntilCutoff(parts, config) {
    var nowSeconds = secondsOfDay(parts.hour, parts.minute, parts.second);
    var cutoffSeconds = secondsOfDay(config.cutoffHour, config.cutoffMinute, 0);
    return (cutoffSeconds - nowSeconds) * 1000;
}

function formatDuration(ms, config) {
    var totalMinutes = Math.floor(ms / 60000);
    if (totalMinutes < 1) {
        return (config.timeMinutes || '{minutes} min').replace('{minutes}', '1');
    }

    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
        return (config.timeHoursMinutes || '{hours} tim {minutes} min')
            .replace('{hours}', String(hours))
            .replace('{minutes}', String(minutes));
    }
    if (hours > 0) {
        return (config.timeHours || '{hours} tim').replace('{hours}', String(hours));
    }
    return (config.timeMinutes || '{minutes} min').replace('{minutes}', String(totalMinutes));
}

function interpolate(template, values) {
    var result = template || '';
    Object.keys(values).forEach(function (key) {
        result = result.split('{' + key + '}').join(values[key]);
    });
    return result;
}

function splitCountdown(template, timeLabel) {
    var rendered = interpolate(template, { time: timeLabel });
    var index = rendered.indexOf(timeLabel);
    if (index === -1) {
        return { prefix: rendered + ' ', time: timeLabel, suffix: '' };
    }
    return {
        prefix: rendered.slice(0, index),
        time: timeLabel,
        suffix: rendered.slice(index + timeLabel.length)
    };
}

function isPdpInStock(el) {
    if (el.getAttribute('data-shipping-promise-in-stock') === 'false') {
        return false;
    }
    var addToCart = document.querySelector('.product-detail .add-to-cart, .product-wrapper .add-to-cart');
    if (addToCart && (addToCart.classList.contains('hide') || addToCart.disabled)) {
        return false;
    }
    return true;
}

function evaluate(placement, config, now) {
    if (!config || !config.enabled || !config.placements || !config.placements[placement]) {
        return { visible: false };
    }

    var parts = getZonedParts(now, config.timezone);
    if (!isWeekdayAllowed(parts, config) || isHoliday(parts, config) || !hasReachedStart(parts, config)) {
        return { visible: false };
    }

    var remaining = msUntilCutoff(parts, config);
    if (remaining <= 0) {
        return { visible: false };
    }

    return {
        visible: true,
        remaining: remaining,
        parts: parts
    };
}

function pushDataLayer(eventName, payload) {
    if (!eventName || typeof window.dataLayer === 'undefined') {
        return;
    }
    window.dataLayer.push(Object.assign({
        event: eventName,
        eventCategory: 'Shipping Promise'
    }, payload));
}

function hideBanner(el, config, reason) {
    var wasVisible = !el.classList.contains('hidden');
    el.classList.add('hidden');
    if (wasVisible && reason === 'cutoff') {
        pushDataLayer(config.analyticsExpireEvent, {
            eventAction: 'expire',
            eventLabel: el.getAttribute('data-shipping-promise'),
            shipping_promise_placement: el.getAttribute('data-shipping-promise')
        });
    }
}

function showBanner(el, config, state) {
    var placement = el.getAttribute('data-shipping-promise');
    var timeLabel = formatDuration(state.remaining, config);
    var headline = interpolate(config.headline, { hour: String(config.cutoffHour) });
    var countdown = splitCountdown(config.countdown, timeLabel);

    var headlineEl = el.querySelector('[data-shipping-promise-headline]');
    var prefixEl = el.querySelector('[data-shipping-promise-countdown-prefix]');
    var timeEl = el.querySelector('[data-shipping-promise-time]');
    var suffixEl = el.querySelector('[data-shipping-promise-countdown-suffix]');

    if (headlineEl) {
        headlineEl.textContent = headline;
    }
    if (placement !== 'checkout' && placement !== 'minicart') {
        if (prefixEl) {
            prefixEl.textContent = countdown.prefix;
        }
        if (timeEl) {
            timeEl.textContent = countdown.time;
        }
        if (suffixEl) {
            suffixEl.textContent = countdown.suffix;
        }
    }

    var wasHidden = el.classList.contains('hidden');
    el.classList.remove('hidden');

    if (wasHidden && !el.getAttribute('data-shipping-promise-tracked')) {
        el.setAttribute('data-shipping-promise-tracked', 'true');
        pushDataLayer(config.analyticsEvent, {
            eventAction: 'view',
            eventLabel: placement,
            shipping_promise_placement: placement,
            shipping_promise_minutes_left: Math.floor(state.remaining / 60000)
        });
    }
}

function isExcluded(el) {
    return el.getAttribute('data-shipping-promise-excluded') === 'true';
}

function tick(el, config) {
    if (isExcluded(el)) {
        hideBanner(el, config, 'excluded');
        return;
    }

    var placement = el.getAttribute('data-shipping-promise');
    if (placement === 'pdp' && !isPdpInStock(el)) {
        hideBanner(el, config, 'stock');
        return;
    }

    try {
        var state = evaluate(placement, config, new Date());
        if (!state.visible) {
            hideBanner(el, config, 'cutoff');
            return;
        }
        showBanner(el, config, state);
    } catch (error) {
        hideBanner(el, config, 'error');
    }
}

function enhance(el, config) {
    if (el.getAttribute('data-shipping-promise-ready')) {
        return;
    }
    el.setAttribute('data-shipping-promise-ready', 'true');
    tick(el, config);
}

function enhanceRoot(root, config) {
    if (!root || !config) {
        return;
    }
    if (root.nodeType === 9) {
        root = root.body || root.documentElement;
    }
    if (!root || root.nodeType !== 1) {
        return;
    }
    if (root.hasAttribute && root.hasAttribute('data-shipping-promise')) {
        enhance(root, config);
    }
    var nodes = root.querySelectorAll('[data-shipping-promise]');
    for (var i = 0; i < nodes.length; i++) {
        enhance(nodes[i], config);
    }
}

var initialized = false;

function init() {
    var config = getConfig();
    if (!config || initialized) {
        return;
    }
    initialized = true;

    enhanceRoot(document, config);

    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
                enhanceRoot(added[j], config);
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setInterval(function () {
        var banners = document.querySelectorAll('[data-shipping-promise][data-shipping-promise-ready]');
        for (var i = 0; i < banners.length; i++) {
            if (document.body.contains(banners[i])) {
                tick(banners[i], config);
            }
        }
    }, 60000);

    if (window.jQuery) {
        window.jQuery('body').on('product:updateAvailability', function (e, response) {
            var container = response && response.$productContainer;
            var root = container && container.jquery ? container.get(0) : container;
            if (!root || !root.querySelectorAll) {
                return;
            }

            var available = response && response.product
                ? response.product.available && response.product.availability
                    && response.product.availability.status !== 'OUT OF STOCK'
                : true;
            var excluded = !!(response && response.product && response.product.shippingPromiseExcluded);
            var pdpBanners = root.querySelectorAll('[data-shipping-promise="pdp"]');
            for (var i = 0; i < pdpBanners.length; i++) {
                pdpBanners[i].setAttribute('data-shipping-promise-in-stock', available ? 'true' : 'false');
                pdpBanners[i].setAttribute('data-shipping-promise-excluded', excluded ? 'true' : 'false');
                tick(pdpBanners[i], config);
            }
        });
    }
}

module.exports = function () {
    init();
};
